import { Component, Input } from '@angular/core';
import { STEP_COLOR_STATUSES } from 'constants/status.constants';
import { StatusIndicatorKinds } from '../status-indicator.component';

const STEP_COLOR_STATUSES_VALUE = {
  [STEP_COLOR_STATUSES.DEFAULT]: StatusIndicatorKinds.DEFAULT,
  [STEP_COLOR_STATUSES.ORANGE]: StatusIndicatorKinds.ORANGE,
  [STEP_COLOR_STATUSES.RED]: StatusIndicatorKinds.RED,
  [STEP_COLOR_STATUSES.PENDING]: StatusIndicatorKinds.GREEN,
  [STEP_COLOR_STATUSES.COMPLETED]: StatusIndicatorKinds.COMPLETED,
  [STEP_COLOR_STATUSES.PARTIALLY_COMPLETED]: StatusIndicatorKinds.DEFAULT,
  [STEP_COLOR_STATUSES.DISABLED]: StatusIndicatorKinds.RED,
  [STEP_COLOR_STATUSES.FAILED]: StatusIndicatorKinds.FAILED,
  [STEP_COLOR_STATUSES.ARCHIVED]: StatusIndicatorKinds.ARCHIVED,
  [STEP_COLOR_STATUSES.PAUSED]: StatusIndicatorKinds.PAUSED,
};

@Component({
  selector: 'cm-status-indicator-step',
  template: `
    <cm-status-indicator [tooltip]="tooltip" [kind]="STEP_COLOR_STATUSES_VALUE[status]"> </cm-status-indicator>
  `,
  styleUrls: ['./status-indicator-step.component.scss'],
})
export class StatusIndicatorStepComponent {
  @Input() status: STEP_COLOR_STATUSES;
  @Input() tooltip: string;
  STEP_COLOR_STATUSES_VALUE = STEP_COLOR_STATUSES_VALUE;
}
